export default __webpack_public_path__ + "static/dd_logo_v3-64302bd2f4d8917654913625485486c5.svg";